import React, { useState, useEffect } from "react";

import img01 from "../../../assets/images/01 cash canvas All in one Financial Management.png";
import img02 from "../../../assets/images/02 Personal Finance AI Insights with CashBot.png";
import img03 from "../../../assets/images/03 Family Financial Planning with shared canvas.png";
import img04 from "../../../assets/images/04 Cash Canvas Savings Tracking.png";
import img05 from "../../../assets/images/05 Cash Canvas InvestmentsTracking.png";

const images = [
  { url: img01, alt: "Cash Canvas - All in one Financial Management" },
  { url: img02, alt: "Cash Canvas - Personal Finance AI Insights" },
  { url: img03, alt: "Cash Canvas - Family Financial Planning" },
  { url: img04, alt: "Cash Canvas - Savings Tracking" },
  { url: img05, alt: "Cash Canvas - Investments Tracking" },
];

const HeroCarousel = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full h-80 md:h-96 rounded-xl overflow-hidden">
      {images.map((img, idx) => {
        const fileName = img.url.split("/").pop().replace(/\.[^/.]+$/, "");
        return (
          <figure
            key={img.url}
            className={`absolute inset-0 w-full h-full transition-opacity duration-700 ${idx === current ? "opacity-100" : "opacity-0"}`}
            aria-hidden={idx === current ? "false" : "true"}
          >
            <img
              src={img.url}
              alt={fileName}
              title={fileName}
              loading="lazy"
              className="w-full h-full object-cover"
            />
            <figcaption className="sr-only">{`${fileName} — ${img.alt}`}</figcaption>
          </figure>
        );
      })}

      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {images.map((_, idx) => (
          <button
            key={idx}
            className={`w-3 h-3 rounded-full border-2 border-white ${idx === current ? "bg-primary-base" : "bg-white bg-opacity-50"}`}
            onClick={() => setCurrent(idx)}
            aria-label={`Go to slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;